import { render, staticRenderFns } from "./LeftNavBase.vue?vue&type=template&id=6a0203fe&scoped=true&"
import script from "./LeftNavBase.vue?vue&type=script&lang=js&"
export * from "./LeftNavBase.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavBase.vue?vue&type=style&index=0&id=6a0203fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0203fe",
  null
  
)

export default component.exports